import ApiService from './ApiService';

const FeedbackService = {
    submit: (options, service = ApiService()) =>
        service.post('/Feedback', options.payload, false).then((response) => response)
        .catch((error) => error.response),
};

export default FeedbackService;
